<template>
  <component
    :is="isMegaMenuMobile ? LazyCmsMegaMenuL1Mobile : LazyCmsMegaMenuL1Desktop"
    v-bind="{ content }"
    @click="handleClick"
    @expand="handleExpand"
  />
</template>

<script lang="ts" setup>
import type { MegaMenuL1Context } from '#content/contexts/megamenu'
import type { MenuItem } from '#types/components/cms/mega-menu'
import { LazyCmsMegaMenuL1Desktop, LazyCmsMegaMenuL1Mobile } from '#components'
import { MegaMenuL1ContextKey, MegaMenuMobileContextKey } from '#content/contexts/megamenu'

const props = defineProps<{
  content: MenuItem
}>()

const { $gtm } = useNuxtApp()
const { getActionLinkHandler, isActionLinkOnly } = useCmsActionLink('header:mega-menu')

const eventLabel = formatMegaMenuLevelLabel(getMegaMenuItemLabel(props.content), 1)

const isMegaMenuMobile = inject(MegaMenuMobileContextKey, false)
const { activeL1, activeL2 } = inject(MegaMenuL1ContextKey, {} as MegaMenuL1Context)

provide(MegaMenuL1ContextKey, { activeL1, activeL2, l1: eventLabel })

const handleClick = () => {
  if (isActionLinkOnly(props.content.target))
    getActionLinkHandler(props.content.target, getMegaMenuItemLabel(props.content))?.()
  $gtm.push('topNav.onClickTopNavLink', eventLabel)
}
const handleExpand = () => $gtm.push('topNav.onClickMobileMenuSection', eventLabel)
</script>
